import { SearchX, Server } from "lucide-react";

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "components/ui/empty";

export function EmptyResults({ hasFilters = false }) {
  return (
    <div className="tw:flex tw:min-h-0 tw:flex-1 tw:items-center tw:justify-center tw:p-4">
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            {hasFilters ? <SearchX /> : <Server />}
          </EmptyMedia>
          <EmptyTitle>
            {hasFilters ? "No machines match" : "No machines"}
          </EmptyTitle>
          <EmptyDescription>
            {hasFilters
              ? "No machines on this case match the current filters."
              : "This case has no machines yet."}
          </EmptyDescription>
        </EmptyHeader>
      </Empty>
    </div>
  );
}
